export default __webpack_public_path__ + "static/media/polygon_svg.0721d093.svg";